import type {PermissionsRecordType} from '../permissions';

export const recordAuditPermissions = {
  recordAuditRead: {
    resourceId: 'RECORD_AUDIT',
    actionId: 'ACCESS',
    scopes: [],
  },
} satisfies PermissionsRecordType;
